import { Role } from '../interfaces/rolesEnum'

interface RolesSelectOption {
  value: keyof typeof Role,
  label: string
}

export function getRolesSelectOptions(role: keyof typeof Role) {
  let roles: RolesSelectOption[] = [{
    value: 'PROMOTER',
    label: 'Promotor',
  }]
  if (role === 'ROOT' ||
    role === 'ADMIN' ||
    role === 'TRADE_MARKETING_COORDINATOR' ||
    role === 'SUPERVISOR') {
    roles = [
      {
        value: 'ADMIN',
        label: 'Administrador',
      },
      {
        value: 'TRADE_MARKETING_COORDINATOR',
        label: 'Coordenador de Trade Marketing',
      },
      {
        value: 'PROMOTER_MANAGER',
        label: 'Gerente de promotores',
      },
      {
        value: 'SUPERVISOR',
        label: 'Supervisor',
      },
      {
        value: 'SELLER',
        label: 'Vendedor',
      },
      {
        value: 'OBSERVER',
        label: 'Diretoria',
      },
      ...roles,
    ]
  }
  // if (role === 'ROOT' ||
  //   role === 'ADMIN' ||
  //   role === 'SUPERVISOR') {
  // }
  return roles
}
